"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DropdownInputItem {
    constructor(value, text) {
        this.value = value;
        this.text = text;
    }
}
exports.default = DropdownInputItem;
